import React from "react";
import classNames from 'classnames';
import styles from "./OpportunityList.module.scss";
import BaseTable, { AutoResizer, Column } from "react-base-table";
import customTableComponents from "./OpportunityListsTableComponent";
import { Spinner } from "@blueprintjs/core";

function OpportunityLists({
  activeOpportunities,
  inactiveOpportunities,
  isLoading,
  topColumns,
  bottomColumns,
  topColumnWidths,
  bottomColumnWidths,
  getColumnWidth,
  onTopColumnResize,
  onBottomColumnResize,
  onOpportunityClick
}) {
  return (
    <div className={styles.listsWrapper}>
      <div className={classNames(styles.tableWrapper, styles.tableWrapperTop)}>
        <AutoResizer>
          {({ width, height }) => {
            return (
              <BaseTable
                fixed
                rowClassName={styles.topTableRow}
                data={activeOpportunities || []}
                width={width}
                height={height}
                components={customTableComponents()}
                emptyRenderer={
                  isLoading ? <div className={styles.empty}><Spinner /></div> : <div className={styles.empty}>No Opportunities Found</div>
                }
                onColumnResizeEnd={onTopColumnResize}
                className={styles.mainTable}
                rowEventHandlers={{
                  onClick: ({ rowData }) => onOpportunityClick(rowData)
                }}
              >
                {topColumns.map((column, index) => (
                  <Column
                    {...column}
                    width={getColumnWidth({ columnWidths: topColumnWidths, index, width })}
                  />
                ))}
              </BaseTable>
            );
          }}
        </AutoResizer>
      </div>
      <div className={styles.tableWrapper}>
        <div className={styles.secondaryTitle}>
          <h2>Inactive Opportunities</h2>
        </div>
          <AutoResizer>
            {({ width, height }) => {
              return (
                <BaseTable
                  fixed
                  data={inactiveOpportunities || []}
                  width={width}
                  height={height}
                  components={customTableComponents()}
                  emptyRenderer={
                    isLoading ? <div className={styles.empty}><Spinner /></div> : <div className={styles.empty}>No Opportunities Found</div>
                  }
                  onColumnResizeEnd={onBottomColumnResize}
                  className={styles.secondTable}
                  rowEventHandlers={{
                    onClick: ({ rowData }) => onOpportunityClick(rowData)
                  }}
                >
                  {bottomColumns.map((column, index) => (
                    <Column
                      {...column}
                      width={getColumnWidth({ columnWidths: bottomColumnWidths, index, width })}
                    />
                  ))}
                </BaseTable>
              );
            }}
          </AutoResizer>
      </div>
    </div>
  );
}

export default OpportunityLists;
